module.exports = __webpack_public_path__ + "Roboto-Italic.5f1ee73e097cc3adf79c.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/roboto/Roboto-Italic.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Italic.woff
// module chunks = 2